import firebase from "../../Config/firebase";
import React, {Component} from "react";
import Compressor from "compressorjs";
import {v4 as uuidv4} from "uuid";
import {MDBCol, MDBContainer, MDBLink, MDBRow} from "mdbreact";
import common from "../../Utils/common.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import classes from "./EditArticle.module.css";
import {Button, Card, CardBody, CardHeader, FormGroup, Input, Label} from "reactstrap";
import ReactQuill from "react-quill";
import {withRouter, Link} from "react-router-dom";

const db =firebase.firestore()
const storageRef = firebase.storage()

class EditArticle extends Component{
    constructor(props) {
        super(props);
        this.state={
            community:{},
            article:{},
            isLoaded:false,
            edited: false,
        }
    }

    modules = {
        toolbar: {
            container:[[{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline','strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                ['clean'],['code-block']
            ],
            handlers:{
                'image': () => this.quillImageCallBack()
            },
            clipboard:{
                matchVisual:false
            }
        }
    }

    formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]

    componentDidMount() {
        if(typeof this.props.location.state !== 'undefined'){
            if (this.props.location.state.hasOwnProperty('article')){
                this.setState({
                    article: this.props.location.state.article
                },() =>{
                    console.log(this.state.article)
                    this.setState({
                        isLoaded:true
                    })
                })
            }
        }
    }

    onChangeArticleTitle = (value) =>{
        this.setState({
            article:{
                ...this.state.article,
                title:value
            }
        },()=>{
            this.setState({
                edited: true
            })
        })
    }

    onChangeArticleContent = (value) =>{
        this.setState({
            article:{
                ...this.state.article,
                content:value
            }
        },()=>{
            this.setState({
                edited: true
            })
        })
    }

    onChangePublish = (val) =>{
        console.log(val)
        this.setState({
            article:{
                ...this.state.article,
                isPublish:val === "True"
            }
        },()=>{
            this.setState({
                edited: true
            })
        })
    }

    editArticle =() =>{
        db.collection('Article')
            .doc(this.state.article.id)
            .update(this.state.article)
    }

    fileCompress = (file) =>{
        return new Promise((resolve,reject)=>{
            console.log(file)
            new Compressor(file, {
                file:'File',
                quality:0.5,
                maxWidth:640,
                maxHeight:640,
                success(file) {
                    return resolve({
                        success:true,
                        file: file
                    })
                },
                error(err) {
                    return resolve({
                        success:false,
                        message:err.message
                    })
                }
            })
        })
    }

    quillImageCallBack = () =>{
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept','image/*')
        input.click()
        input.onchange = async () =>{
            const file = input.files[0]
            const compressState = await this.fileCompress(file)
            if(compressState.success){
                const fileName = uuidv4()
                storageRef.ref().child('Article/' + fileName).put(compressState.file)
                    .then(async snapshot=>{
                        const downloadURL= await storageRef.ref().child('Article/' + fileName).getDownloadURL()
                        console.log(downloadURL)
                        let quill = this.quill.getEditor()
                        const range =quill.getSelection(true)
                        quill.insertEmbed(range.index,'image',downloadURL)
                    })
            }
        }
    }



    render() {
        if(this.state.isLoaded){
            return(
                <MDBContainer>
                    {/*<button className={common.BackBtn}*/}
                    {/*        onClick={(e) => {*/}
                    {/*            this.props.history.goBack()*/}
                    {/*        }}*/}
                    {/*>*/}
                    {/*    <FontAwesomeIcon icon={faArrowLeft}/>*/}
                    {/*</button>*/}
                    <MDBRow>
                        <MDBCol xl={9} lg={9} md={8} sm={12} xs={12}>
                            <h2 className={classes.SectionTitle}>Edit Article</h2>
                            <FormGroup>
                                <Label className={classes.Label}>Title</Label>
                                <Input type='text' name='articleTitle' id='articleTitle'
                                       onChange={(e)=>this.onChangeArticleTitle(e.target.value)}
                                       value={this.state.article.title}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ReactQuill
                                    ref={(el) => this.quill = el}
                                    value ={this.state.article.content}
                                    onChange={(e)=> this.onChangeArticleContent(e)}
                                    theme='snow'
                                    modules={this.modules}
                                    formats={this.formats}
                                />
                            </FormGroup>
                        </MDBCol>
                        <MDBCol xl={3} lg={3} md={4} sm={12} xs={12}>
                            <Card>
                                <CardHeader>
                                    Article Setting
                                </CardHeader>
                                <CardBody>
                                    <FormGroup>
                                        <Label className={classes.Label}>Publish</Label>
                                        <Input type='select' name='publish' id='publish'
                                               onChange={(e)=>this.onChangePublish(e.target.value)}>
                                            <option selected={this.state.article.isPublish === false}>False</option>
                                            <option selected={this.state.article.isPublish === true}>True</option>
                                        </Input>
                                    </FormGroup>
                                    {console.log(this.state.article)}
                                    <FormGroup>
                                        <Link to={{pathname:'/admin/articleList'}}>
                                        <Button disabled={!this.state.edited} color='danger'
                                            onClick={(e)=>this.editArticle()}>
                                            Save
                                        </Button>
                                        </Link>
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            )
        } else {
            return(
                <div>
                    Loading...
                </div>
            )
        }
    }
}
export default withRouter(EditArticle)